import { useEffect, useMemo, useState } from "react";
import styles from "./EnterpriseDataTable.module.css";
import { SORTING_OPTIONS } from "../../../../constant";
import DataTableWithFilters from "../../../CommonComponents/DataTableWithFilters";
import { HiOutlineDotsVertical } from "react-icons/hi";
import ActionMenu from "../../../CommonComponents/ActionMenu";
import { ENTERPRISE_COMPANY } from "../../../../urlConfig";
import { formatNumbers } from "../../../../utils/NumberFormat";
import { useNavigate } from "react-router-dom";
import EnterpriseServices from "../../../../services/EnterpriseServices";
import useNotification from "../../../../hooks/useNotification";
import userAvatar from "../../../../assets/userAvatar-Other.png";

const EnterpriseDataTable = () => {
  const [counts, setCounts] = useState(0);
  const navigate = useNavigate();
  const [selectedSort, setSelectedSort] = useState(["Most Recent"]);
  const [searchInput, setSearchInput] = useState("");
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState();
  const [prevPage, setPrevPage] = useState();
  const [total, setTotal] = useState(100);

  const fetchUserOverviewData = async (nextPage, prevPage) => {
    setLoading(true);

    let queryParams = [`pageSize=10`];

    if (nextPage) queryParams.push(`nextPage=${nextPage}`);
    if (prevPage) queryParams.push(`prevPage=${prevPage}`);
    if (searchInput) queryParams.push(`search=${searchInput}`);

    let str = queryParams.join("&");

    const res = await EnterpriseServices.getEnterpriseList(str);

    if (res) {
      if (res.statusCode === 1) {
        setData(res.data);
        setTotal(res.total);
        setNextPage(res.nextPage);
        setPrevPage(res.prevPage);
      } else {
        handleError(`${res.statusDesc}`);
      }
    } else {
      handleError(`Error: ${res.statusDesc}`);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUserOverviewData();
  }, []);

  const handleDelete = (id) => {
    console.warn("delete clicked", id);
  };

  const revokeAccess = async (data) => {
    console.log("id", data);
    if (data?._id) {
      try {
        setLoading(true);
        let res = await EnterpriseServices.revokeAccess(data?._id);
        if (res) {
          if (res.statusCode === 1) {
            fetchUserOverviewData();
            showNotification(
              `Enterprise access ${!data.isActive ? "Re-initated" : "Revoked"}`
            );
          } else {
            handleError(`${res.statusDesc}`);
          }
        } else {
          handleError(`Error: ${res.statusDesc}`);
        }
        setLoading(false);
      } catch (error) {
        console.error(error);
        handleError(`Error: ${error.message}`);
      }
    }
  };

  const handleClick = (record) => {
    navigate(ENTERPRISE_COMPANY + record._id);
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const handleSearch = (value) => {
    setSearchInput(value);
  };

  const handlePageChange = (isNextPage) => {
    if (isNextPage) {
      fetchUserOverviewData(nextPage, "", false);
    } else {
      fetchUserOverviewData("", prevPage, true);
    }
  };

  useEffect(() => {
    fetchUserOverviewData();
  }, [searchInput]);

  const columns = [
    {
      title: `Enterprises (${total})`,
      dataIndex: "companyName",
      key: "companyName",
      minWidth: 200,
      render: (name, record) => {
        return (
          <div
            className={styles.user_image_wrap}
            onClick={() => handleClick(record)}
          >
            <img
              src={
                record?.companyImage?.docs
                  ? record?.companyImage?.docs
                  : userAvatar
              }
              alt="user avatar"
            />
            {name}
          </div>
        );
      },
    },
    {
      title: "Active Roles",
      dataIndex: "activeJobCount",
      minWidth: 120,
      key: "activeJobCount",
      sorter: (a, b) => a.activeJobCount - b.activeJobCount,
      render: (activeJobCount, record) => {
        return (
          <div className={styles.applicants_cell}>
            {formatNumbers(activeJobCount)}
          </div>
        );
      },
    },
    // {
    //   title: "Invoice",
    //   dataIndex: "type",
    //   key: "type",
    //   minWidth: 120,
    //   sorter: (a, b) => a.type.localeCompare(b.type),
    //   render: (type, record) => {
    //     return (
    //       <div
    //         className={`${styles.status_cell}  ${styles[`${type.toLowerCase().replace(/ /g, "")}_status`]
    //           }`}
    //       >
    //         {type}
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Plan",
      dataIndex: "subscriptionName",
      key: "subscriptionName",
      minWidth: 120,
      sorter: (a, b) => a.subscriptionName.localeCompare(b.subscriptionName),
      render: (subscriptionName, record) => {
        return <div className={styles.tag_cell}>{subscriptionName}</div>;
      },
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      minWidth: 120,
      sorter: (a, b) => (a.isActive === b.isActive ? 0 : a.isActive ? 1 : -1),
      render: (status, record) => {
        return (
          <div
            className={`${styles.status_cell}
              }`}
          >
            {status ? "Active" : "Revoked"}
          </div>
        );
      },
    },
    {
      title: "",
      dataIndex: "Actions",
      key: "Actions",
      minWidth: 10,
      maxWidth: 15,
      render: (status, record) => {
        return (
          <div>
            <ActionMenu
              options={[
                {
                  label: "Edit",
                  route: ENTERPRISE_COMPANY + record.key,
                },
                {
                  label: !record.isActive
                    ? "Re-initate Access"
                    : "Revoke Access",
                  action: () => revokeAccess(record),
                },
              ]}
            />
          </div>
        );
      },
    },
  ];

  const handleSortChange = (value) => {
    setSelectedSort(value);
  };

  const handleFilterChange = (value) => {};

  return (
    <div className={styles.content_wrap}>
      <DataTableWithFilters
        columns={columns}
        data={data}
        setCounts={setCounts}
        sortOptions={SORTING_OPTIONS}
        handleFilterChange={handleFilterChange}
        handleSortChange={handleSortChange}
        selectedSort={selectedSort}
        handleSearch={handleSearch}
        tableKey={"key"}
        pageSize={10}
        loading={loading}
        total={total}
        handlePageChange={handlePageChange}
        scroll={{
          x: "max-content",
        }}
      />
    </div>
  );
};

export default EnterpriseDataTable;
